import { Label, MultiSelect, PageTabsContent } from "@tellescope/ui";
import { useTranslation } from "react-i18next";
import { EditUserForm } from "./useEditUserForm";

export interface AdminTabContentProps {
  form: EditUserForm;
}

export const AdminTabContent = ({ form }: AdminTabContentProps) => {
  const { t } = useTranslation("settings");

  const ssoOptions = [
    { value: "Google", label: t("Google") },
    { value: "Microsoft", label: t("Microsoft") },
    { value: "Okta", label: t("Okta") },
  ];

  return (
    <PageTabsContent
      value="admin"
      className="px-6 py-4 space-y-4 overflow-y-auto"
      style={{
        maxHeight: "min(80vh, 900px)",
      }}
    >
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="requireSSO">{t("Require SSO")}</Label>
          <MultiSelect
            id="requireSSO"
            options={ssoOptions}
            {...form.getCustomFieldProps("requireSSO")}
            placeholder={t("Leave blank to allow login with password")}
            searchPlaceholder={t("Search...")}
            emptyText={t("No options found")}
          />
        </div>
      </div>
    </PageTabsContent>
  );
};
